import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { XeroObjectDataset } from 'app/model/dataset/xero.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'XeroSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(XeroObjectDataset) }
})
export class XeroCopySource extends TabularCopySource {
}
